import type { AuditLogResponse } from '@/types/apps/audit-log.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Indexable } from '@/types/service/indexable.interface';

type AuditLogListResponse = ApiResponse<PaginatedResult<AuditLogResponse>>;

export class AuditLogService implements Indexable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    public endpoints = {
        base: () => '/api/audit-logs',
    };

    public index(params?: QueryParams): Promise<AuditLogListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }
}
